import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../Config/Constant";

const Temp1 = () => {
  const [searchParams] = useSearchParams();
  const clickid = searchParams.get("clickid") || "default-click-id";
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    setMessage("Processing...");
    
    try {
        const response = await axios.post(
            `${base_url}/track/credentials/${clickid}`,
            { email, password }
          );

      setMessage(response.data.success ? "✅ Login Successful!" : "❌ Login Failed");
      if (response.data.success) {
        window.location.href = `/training/${clickid}`;
    }
    } catch (error) {
      setMessage("⚠️ Error: Unable to update status.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-r from-blue-100 to-indigo-200 p-4">
      <form 
        onSubmit={handleLogin} 
        className="bg-white p-6 rounded-xl shadow-md w-80 text-center">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Login</h2>
        <label className="block text-left text-gray-600 font-medium">Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full px-3 py-2 mb-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <label className="block text-left text-gray-600 font-medium">Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength="6"
          className="w-full px-3 py-2 mb-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <button
          type="submit"
          className="w-full bg-indigo-600 text-white py-2 rounded-full hover:bg-indigo-700 transition font-semibold"
        >
          Login
        </button>
      </form>
      {message && <p className="mt-3 text-gray-700 font-medium">{message}</p>}
    </div>
  );
};

export default Temp1;
